import * as React from 'react';
// import ReactDOM from 'react-dom';

import { Config } from '../Config.js';
import { Session } from './Session.js';
import { Utils } from './Utils.js';

const sessione = new Session();
const config = new Config();
const utils = new Utils();


export class PdfFromApi extends React.Component {    
    
    loadFromApi(){
        // gestione da MS381_AC2_CUSTOMIZATION
        if( utils.getObjInfoSocieta( 'BOLLETTA_VIA_API' , 'NO' ) !== 'NO' 
                    && utils.getObjInfoSocieta( 'BOLLETTA_VIA_API' , 'NO' ) !== ''
                    && utils.getObjInfoSocieta( 'BOLLETTA_VIA_API' , 'NO' ) !== null ){
            return true;
        }
        return false;
    }
    
    bottonePdfApi( item ){
        
        let user = sessione.get('datiutente');
        
        let TIPOAPI = utils.getObjInfoSocieta( 'BOLLETTA_VIA_API' , 'NO' );
        
        if( TIPOAPI === 'ONDA'){
            this.loadBottoneApiOnda( item , user );
        }
    }
    
    loadBottoneApiOnda( item , user){
        let url = config.get('scaricapdfapi');
        let API = utils.getObjInfoSocieta( 'BOLLETTA_VIA_API' , 'NO' );
        //window.open(url);
        
        var formAPI = document.createElement("form");
        formAPI.target = "_blank";
        formAPI.method = "POST";
        formAPI.action = url;
        
        
        var apiInput = document.createElement("input");
        apiInput.type = "text";
        apiInput.name = "APITYPE";
        apiInput.value = API;
        formAPI.appendChild(apiInput);
        
        var uInput = document.createElement("input");
        uInput.type = "text";
        uInput.name = "USER";
        uInput.value = JSON.stringify(user);
        formAPI.appendChild(uInput);
        
        var iInput = document.createElement("input");
        iInput.type = "text";
        iInput.name = "ITEM";
        iInput.value = JSON.stringify(item);
        formAPI.appendChild(iInput);
        
        let d = new Date();
        let code = user.COD_CLIENTE+'-'+d.getFullYear()+'ON'+d.getDate()+'DA'+( d.getMonth()+1);
        
        
        var cInput = document.createElement("input");
        cInput.type = "text";
        cInput.name = "CODE";
        cInput.value = btoa(code);
        formAPI.appendChild(cInput);
        
        document.body.appendChild(formAPI);                       
        formAPI.submit();
        document.body.removeChild(formAPI);
    }
}
export default PdfFromApi;


// WEBPACK FOOTER //
// ./src/AcComponents/classi/PdfFromApi.js